import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { useSession } from 'next-auth/react';

import { useModalStore } from '@/store/modal.store';

export const useReferral = () => {
  const searchParams = useSearchParams();
  const { setIsOpenAuthDialog } = useModalStore();
  const { data: session, status } = useSession();

  useEffect(() => {
    if (status === 'loading') return;
    const register = searchParams.get('register');
    if (register === '1' || register === 'true') {
      if (!session) {
        setIsOpenAuthDialog(true);
      }
    }
  }, [searchParams, setIsOpenAuthDialog, session, status]);

  useEffect(() => {
    // Проверяем, есть ли реферальный код в URL
    const ref = searchParams.get('ref');

    if (ref) {
      console.log('=== REFERRAL DETECTED ===');
      console.log('Referral code:', ref);
      console.log('Current URL:', window.location.href);

      // Сохраняем реферальный код в localStorage
      localStorage.setItem('molwe_referral', ref);

      // Также сохраняем полную реферальную ссылку
      localStorage.setItem('molwe_referral_url', window.location.href);

      // Сохраняем timestamp
      localStorage.setItem('molwe_referral_timestamp', Date.now().toString());

      console.log('Referral data saved to localStorage');
      console.log('=== END REFERRAL ===');

      if (ref === 'gikkon' && status !== 'loading' && !session) {
        setIsOpenAuthDialog(true);
      }

      // Очищаем URL от реферального параметра (опционально)
      // Это можно раскомментировать, если хочешь убрать ref из URL
      // const url = new URL(window.location.href)
      // url.searchParams.delete('ref')
      // window.history.replaceState({}, '', url.toString())
    }
  }, [searchParams, setIsOpenAuthDialog, session, status]);

  // Функция для получения сохраненного реферального кода
  const getReferral = () => {
    return localStorage.getItem('molwe_referral');
  };

  // Функция для получения полной реферальной ссылки
  const getReferralUrl = () => {
    return localStorage.getItem('molwe_referral_url');
  };

  // Функция для получения timestamp реферальной ссылки
  const getReferralTimestamp = () => {
    const timestamp = localStorage.getItem('molwe_referral_timestamp');
    return timestamp ? parseInt(timestamp, 10) : null;
  };

  // Функция для очистки реферальных данных
  const clearReferral = () => {
    localStorage.removeItem('molwe_referral');
    localStorage.removeItem('molwe_referral_url');
    localStorage.removeItem('molwe_referral_timestamp');
  };

  // Функция для проверки, является ли текущая сессия реферальной
  const isReferralSession = () => {
    return !!getReferral();
  };

  return {
    getReferral,
    getReferralUrl,
    getReferralTimestamp,
    clearReferral,
    isReferralSession,
  };
};
